import { render, staticRenderFns } from "./ActivixBaseButton.vue?vue&type=template&id=ff24877c&"
import script from "./ActivixBaseButton.vue?vue&type=script&lang=js&"
export * from "./ActivixBaseButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports